import { render, staticRenderFns } from "./Part3.vue?vue&type=template&id=3868ab44&scoped=true&"
import script from "./Part3.vue?vue&type=script&lang=js&"
export * from "./Part3.vue?vue&type=script&lang=js&"
import style0 from "./Part3.vue?vue&type=style&index=0&id=3868ab44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3868ab44",
  null
  
)

export default component.exports